"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchEngineUrl = exports.SearchEngineTitle = exports.SearchEnginePreview = exports.SearchEngineDescription = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var SearchEnginePreview = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    font-family: arial, sans-serif;\n"])));

exports.SearchEnginePreview = SearchEnginePreview;

var SearchEngineUrl = _styledComponents["default"].a(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: center;\n"])));

exports.SearchEngineUrl = SearchEngineUrl;

var SearchEngineTitle = _styledComponents["default"].a(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    display: block;\n    margin: 0.3rem 0;\n    font-size: 1rem;\n    font-weight: 600;\n"])));

exports.SearchEngineTitle = SearchEngineTitle;

var SearchEngineDescription = _styledComponents["default"].p(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    margin-bottom: 0;\n    font-size: 0.8rem;\n    color: #999;\n"])));

exports.SearchEngineDescription = SearchEngineDescription;